<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      timer: null,
    };
  },
};
</script>
<style lang="scss">
body,
html {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  #app {
    width: 100%;
    height: 100%;
    overflow: overlay;
    background: $appBG;
  }
}
</style>
